import styled from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'
import Icon from '../../components/Icon'

type InputStateProps = {
  $isError?: boolean
}

export const Container = styled.label<InputStateProps>`
  --filtercheck-color: rgba(0, 0, 0, 0.3);
  position: relative;
  display: inline-grid;
  grid-template-columns: [check] auto [label] auto;
  grid-template-rows: auto;
  align-items: center;
  gap: ${pxToRem(8)};
  min-height: ${pxToRem(38)};
  padding-inline: ${pxToRem(16)};
  padding-block: ${pxToRem(8)};
  border: 1px solid var(--filtercheck-color);
  border-radius: ${pxToRem(48)};
  transition: border-color 0.3s ease-in-out;
  background-color: ${({ theme }) => theme.colors.white};
  &:has(input:disabled) {
    --filtercheck-color: rgba(0, 0, 0, 0.3);
    cursor: not-allowed;
  }
  &:has(input:not(:disabled)) {
    cursor: pointer;
  }
  &:hover:has(input:not(:disabled)),
  &:focus-within:has(input:not(:disabled)) {
    --filtercheck-color: rgba(0, 0, 0, 0.5);
  }
  &:has(input:checked):has(input:not(:disabled)) {
    --filtercheck-color: rgba(0, 0, 0, 1);
  }
`
export const Input = styled.input<InputStateProps>`
  position: absolute;
  opacity: 0;
  @media ${mq(sizes.tablet)} {
  }
`
export const Label = styled.span<InputStateProps>`
  ${({ theme }) => theme.textStyles.d1440_tags}
  grid-column: label / span 1;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.black};
  transition: color 0.3s ease-in-out;
  input:disabled ~ & {
    color: var(--filtercheck-color);
  }
`

export const _Icon = styled(Icon)`
  grid-column: check / span 1;
  grid-row: 1 / span 1;
  aspect-ratio: 1;
  width: ${pxToRem(12)};
  opacity: 0;
  color: var(--filtercheck-color);
  transition:
    color 0.3s ease-in-out,
    opacity 0.3s ease-in-out;
`
export const OnIcon = styled(_Icon)`
  input:checked ~ & {
    opacity: 1;
  }
`
export const OffIcon = styled(_Icon)`
  input:not(:checked) ~ & {
    opacity: 1;
  }
`
